import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { Icons } from 'components';
import { useComponentVisible } from 'utils/functions/detectClickOutside';
import { AutoSuggestDropdownStyled } from './styled';

const AutoSuggestDropdown = ({
  theme_autosugget,
  theme_log,
  placeholderDropdown = 'เลือก',
  placeholderInput = 'ค้นหา',
  category = '',
  showAllOption = true,
  showSearch = true,
  options,
  minwidth,
  onChangeCustom,
  onChange,
  value,
  errors,
  disabled,
  fetchApi,
  heightInput,
  fontSize,
  params,
  placeholderDropdownAll,
  iconColor = '#002366',
}) => {
  const customClass = cx({
    theme_autosugget: theme_autosugget,
    theme_log: theme_log,
  });

  const timerRef = useRef(null);
  const [_value, _setValue] = useState();
  const [, _setKeyword] = useState();
  const [_textValue, _setTextValue] = useState('');
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const dropdownRef = useRef(null);
  const [dropdownDirection, setDropdownDirection] = useState('down');

  const handleClickShow = () => {
    if (!disabled) {
      setIsComponentVisible(!isComponentVisible);
    }
  };

  useEffect(() => {
    _setValue(value || null);
  }, [value]);

  useEffect(() => {
    if (isComponentVisible && dropdownRef.current) {
      const dropdownEl = dropdownRef.current;
      const parentEl = dropdownEl.parentElement;

      if (parentEl) {
        const parentRect = parentEl.getBoundingClientRect();
        const dropdownHeight = dropdownEl.offsetHeight;
        const spaceBelow = window.innerHeight - parentRect.bottom;
        const spaceAbove = parentRect.top;

        if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
          setDropdownDirection('up');
        } else {
          setDropdownDirection('down');
        }
      }
    }
  }, [isComponentVisible]);

  const handleClickOpt = (e) => {
    _setValue(e);
    setIsComponentVisible(false);
    onChangeCustom && onChangeCustom(e);
    onChange && onChange(e);
    if (e.value === 'all') {
      _setKeyword(null);
      _setTextValue('');
      fetchApi &&
        fetchApi(
          `${category ? category : ''}?per_page=300&offset=0`,
          category
        );
    }
  };

  const handleKeySearch = (e) => {
    _setTextValue(e.target.value);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(async () => {
      let tempKeyword =
        e.target.value && e.target.value !== '' ? e.target.value : '';
      _setKeyword(tempKeyword);

      fetchApi &&
        fetchApi(
          `${category ? category : ''}?per_page=300&offset=0${params ? params : ''}${tempKeyword && tempKeyword !== '' ? `&keyword=${tempKeyword}` : ''
          }`,
          category
        );
    }, 500);
  };

  const handleSearch = () => {
    fetchApi &&
      fetchApi(
        `${category ? category : ''}?per_page=300&offset=0${params ? params : ''}${_textValue && _textValue !== '' ? `&keyword=${_textValue}` : ''
        }`,
        category
      );
  };

  return (
    <AutoSuggestDropdownStyled
      minwidth={minwidth}
      disabled={disabled}
      heightInput={heightInput}
      fontSize={fontSize}
      direction={dropdownDirection}
    >
      <div ref={ref} className={customClass}>
        <div
          className={`body_autosuggest ${isComponentVisible ? 'open' : ''}`}
          onClick={handleClickShow}
        >
          <div className={`value_show ${_value ? 'txt_color' : ''}`}>
            {_value ? (
              <>
                {_value.icon && <span className="icon_opt">{_value.icon}</span>}
                {_value.label}
              </>
            ) : placeholderDropdown}
          </div>
          <div className="svg_d">
            {isComponentVisible ? (
              <Icons.ArrowUp2 color={disabled ? '#949494' : iconColor} />
            ) : (
              <Icons.ArrowDown2 color={disabled ? '#949494' : iconColor} />
            )}
          </div>
        </div>
        {isComponentVisible && (
          <div
            className={`otp_show ${dropdownDirection}`}
            ref={dropdownRef}
          >

            <div className="render_opt">
              {showSearch && (
                <div className="box_search">
                  <input
                    className="input_search"
                    value={_textValue}
                    placeholder={placeholderInput}
                    onChange={handleKeySearch}
                  />
                  <div className="svg_search" onClick={handleSearch}>
                    <Icons.Search2 width="18" height="18" />
                  </div>
                </div>
              )}
              <div className="opt_zone_box">
                {options &&
                  [...(showAllOption ? [{ label: placeholderDropdownAll ? placeholderDropdownAll : 'ทั้งหมด', value: 'all' }] : []), ...options].map((e, i) => (
                    <div
                      key={i + 1}
                      className={`opt_box ${_value && e.value === _value.value ? 'select' : ''
                        }`}
                      onClick={() => handleClickOpt(e)}
                    >
                      <div className="lbl_opt">
                        {e.icon && <span className="icon_opt">{e.icon}</span>}
                        {e.label}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {errors && <div className="error">{`* ${errors}`}</div>}
      </div>
    </AutoSuggestDropdownStyled>
  );
};

export default AutoSuggestDropdown;
